module.exports = __webpack_public_path__ + "img/business-befikar-mobile.0474530a.png";